// @flow

import styled from 'styled-components';
import type { Theme } from '../../../types';

// TODO: do we need to set the specs color to the specs?
export default styled<any, Theme>('h3')`
  color: ${props => props.theme.carblock.color};
  font-size: ${props => props.theme.carblock.specs.fontSize.default};
  font-weight: ${props => props.theme.carblock.specs.fontWeight};
`;
